<template>
  <div>
    <div class="sidebar">
      <ul>
        <li @click="showServicePopup=!showServicePopup">
          <i class="icon-service"></i>
          <p>客服</p>
        </li>
        <li @mouseover="showQrcode=true" @mouseout="showQrcode=false">
          <i class="icon-qrcode"></i>
          <div class="qrcode-wrap" v-if="showQrcode">
            <img src="https://www.huishoubao.com/static/pc/1001/img/logo-lxjq12.png">
            <p>关注公众号</p>
            <p>更多好礼相送</p>
          </div>
        </li>
        <li @click="backTop">
          <i class="icon-backtop"></i>
          <p>TOP</p>
        </li>
      </ul>
    </div>
    <serverPopup v-model="showServicePopup"></serverPopup>
  </div>
</template>

<script>
import serverPopup from '../service-popup';
export default {
  components: {
    serverPopup
  },
  data () {
    return {
      showServicePopup: false,
      showQrcode: false
    };
  },
  methods: {
    backTop () {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="postcss" scoped>
.sidebar {
  z-index: 200;
  width: 58px;
  height: 236px;
  position: fixed;
  right: 15px;
  bottom: 200px;
  font-size: 12px;
  color: #999;
  text-align: center;
  background-color: #fff;
}

li {
  position: relative;
  width: 58px;
  cursor: pointer;
  border: 1px solid #e9ebed;
  &:hover {
    border-color: #fabe00;
  }
}

p {
  line-height: 24px;
}

.icon-service {
  display: block;
  height: 60px;
  background: url(https://www.huishoubao.com/static/pc/1001/img/logo-headset.png) no-repeat center 6px;
}

.icon-qrcode {
  display: block;
  height: 80px;
  background: url(https://www.huishoubao.com/static/pc/1001/img/logo-smlq.jpg) no-repeat center;
  background-size: 100%;
}

.icon-backtop {
  display: block;
  width: 56px;
  height: 42px;
  background: url(https://www.huishoubao.com/static/pc/1001/img/logo-top.png) no-repeat center 12px;
}

.qrcode-wrap {
  position: absolute;
  top: 0;
  left: -105px;
  width: 100px;
  height: 148px;
  background-color: #fff;
  border: 1px solid #eee;
  img {
    width: 90px;
    height: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/sidebar/index.vue